/**
 * <s-header-fit>
 * Wraps the header row and keeps the desktop navigation on one line, also with
 * longer translated menu titles. When the menu does not fit, it steps through
 * compact levels via `data-fit` (1: icon-only search, 2: tighter spacing,
 * 3: slightly smaller menu text) and stops at the first level that fits.
 */
class SHeaderFit extends HTMLElement {
  connectedCallback() {
    this.check = () => {
      const nav = this.querySelector('[data-desktop-nav]');
      this.removeAttribute('data-fit');
      if (!nav || getComputedStyle(nav).display === 'none') return;
      for (let level = 0; level <= 3; level++) {
        if (level > 0) this.setAttribute('data-fit', String(level));
        if (this.fits(nav)) return;
      }
    };
    this.observer = new ResizeObserver(this.check);
    this.observer.observe(this);
    this.check();
    document.fonts?.ready.then(this.check);
  }

  fits(nav) {
    const range = document.createRange();
    range.selectNodeContents(nav);
    return range.getBoundingClientRect().width <= nav.clientWidth + 1;
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('s-header-fit')) {
  customElements.define('s-header-fit', SHeaderFit);
}
